import { jsx as _jsx } from "react/jsx-runtime";
import { ConfigProvider } from "antd";
import "./ThemeWrapper.scss";
import { defaultTheme } from "../../assets/theme/default";
// inject tailwind styling
import "../../assets/styles/styles.css";
import { useKeyboardNavigationDetector } from "./ThemeWrapperUtils";
/**
 * The ThemeWrapper component acts as a context provider,
 * offering theming for antd components and te-ui components
 * that depend on or use the antd theme, such as through tokens.
 * It also includes Tailwind styles, making them accessible to all components.
 */
export const ThemeWrapper = ({ theme = defaultTheme, locale, children, defaultComponentSize = "middle" }) => {
    useKeyboardNavigationDetector();
    return (_jsx(ConfigProvider, { locale: locale, theme: theme, componentSize: defaultComponentSize, children: children }));
};
